import * as types from 'src/localization/types';

export const localized = (env: types.Env) => ({
  connectionGuide: env.localizer('components.InstitutionRelatedArticles.connectionGuide')
});
